import { updateSettings } from '../../../../../react/features/base/settings/actions';
import { toggleAutoPIP, toggleAutostartRecording, toggleAutostartTranscription, togglePreJoinScreen, togglePreJoinScreenExternal } from '../../../customStorageSettings/actions';
import { submitHintsTab } from '../../../hints/components/web/actions';
import { submitNoiseTab } from '../../../noise-suppression/components/web/actions.web';
export function submitAdvancedTab(props) {
    return async (dispatch, getState) => {
        const { autoPipEnabled, transcriptionAutostart, recordingAutostart, preJoinScreen } = props;
        // Transcription
        dispatch(toggleAutostartTranscription(transcriptionAutostart));
        dispatch(toggleAutostartRecording(recordingAutostart));
        const state = getState();
        const { isPreJoinScreen, isPreJoinScreenExternal, isAutoPip } = state['wildix/customStorageSettings'];
        if (preJoinScreen !== isPreJoinScreen || preJoinScreen !== isPreJoinScreenExternal) {
            // If ctijid exist it means than user joined with PBX
            const { ctijid } = state['features/base/settings'];
            dispatch(updateSettings({
                userSelectedSkipPrejoin: !preJoinScreen
            }));
            if (ctijid) {
                dispatch(togglePreJoinScreen(preJoinScreen));
            }
            else {
                dispatch(togglePreJoinScreenExternal(preJoinScreen));
            }
        }
        // END Transcription
        // Auto PIP
        if (autoPipEnabled !== isAutoPip) {
            dispatch(toggleAutoPIP(autoPipEnabled));
        }
        // END Auto PIP
        // Noise
        dispatch(submitNoiseTab(props));
        // END Noise
        // Hints
        dispatch(submitHintsTab(props));
        // END Hints
    };
}
